import { Button, Input, Modal, Popconfirm, Space, Tag, Tooltip, message } from "antd";
import BigScreenApi from "../../api/BigScreenApi";
import { useEffect, useState } from "react";
import Table, { ColumnType } from "antd/es/table";
import StringUtils from "../../util/StringUtils";
import TimeUtils from "../../util/TimeUtils";
import { BigScreenManagementWrapper, TableWrapper, ToolBarLeftWrapper, ToolBarRightWrapper, ToolBarWrapper } from "./BigScreenManagement.styled";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import CreateBigScreenWizard from "./components/create-big-screen-wizard/CreateBigScreenWizard";
import PermissionWrapper from "../../components/permission/PermissionWrapper";

interface BigScreenManagementProps {

}

const BigScreenManagement: React.FC<BigScreenManagementProps> = (props)=> {
    // api
    let bigScreenApi = new BigScreenApi();
    const [messageApi, contextHolder] = message.useMessage();

    // state
    let [loading, setLoading] = useState(true);
    let [bigScreenViews, setBigScreenViews] = useState([]);
    let [openCreateBigScreenModal, setOpenCreateBigScreenModal] = useState(false);
    let [editingBigScreenId, setEditingBigScreenId] = useState(null);
    let [searchValue, setSearchValue] = useState("");

    // events
    let onEditBigScreenInfo = (bigScreenView: any)=> {
        setEditingBigScreenId(bigScreenView.bigScreen.id);
        setOpenCreateBigScreenModal(true);
    };

    let onAddBigScreenClick = ()=> {
        setEditingBigScreenId(null);
        setOpenCreateBigScreenModal(true);
    };

    let onDeleteBigScreen = async (bigScreenView: any)=> {
        await bigScreenApi.delete(bigScreenView.bigScreen.id);
        messageApi.open({
            type: 'success',
            content: '删除大屏成功',
        });
        loadBigScreenViews();
    };

    let onInputChange = (e)=> {
        setSearchValue(e.target.value);
    };

    let onView = (bigScreenView: any)=> {
        // todo
    };

    let onOpenEditor = (bigScreenView: any)=> {
        let bigScreen = bigScreenView.bigScreen;
        let editorUrl = '/static/big-screen/editor/index.html';
        let separator = editorUrl.indexOf('?') >= 0 ? '&' : '?';
        let fullEditorUrl = editorUrl + separator + 'id=' + bigScreen.id;
        window.open(fullEditorUrl, '_blank');
    };

    // load big screen views
    let loadBigScreenViews = async ()=> {
        setLoading(true);
        let bigScreenViews = (await bigScreenApi.getAllBigScreenViews()).data.data;
        setBigScreenViews(bigScreenViews);
        setLoading(false);
    }

    // column definition
    let columns: ColumnType<any>[] = [
        {
            title: '大屏名称',
            dataIndex: 'bigScreen.name',
            key: 'bigScreen.name',
            align: 'center',
            render: (text, record, index)=> {
                return <a onClick={()=> onEditBigScreenInfo(record)}>{record.bigScreen.name}</a>
            }
        },
        {
            title: '创建时间',
            dataIndex: 'bigScreen.createTime',
            key: 'bigScreen.createTime',
            align: 'center',
            render: (text, record, index)=> {
                let createTime = record.bigScreen.createTime;
                if (createTime == null) {
                    return <span>N/A</span>
                }
                return <span>{TimeUtils.formatTimestamp(createTime, 'YYYY-MM-DD HH:mm:ss')}</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'bigScreen.remarks',
            key: 'bigScreen.remarks',
            align: 'center',
            ellipsis: true,
            render: (text, record, index)=> {
                return <span>{StringUtils.emptyToSlash(record.bigScreen.remarks)}</span>
            }
        },
        {
            title: '操作',
            key: 'action',
            align: 'center',
            width: 260,
            render: (text, record, index)=> {
                return <Space size="middle">
                    <PermissionWrapper permissionCodePath="system-overview.big-screen-management.view-big-screen">
                        <a onClick={()=> onOpenEditor(record)}>观看大屏</a>
                    </PermissionWrapper>

                    <PermissionWrapper permissionCodePath="system-overview.big-screen-management.edit-big-screen">
                        <a onClick={()=> onOpenEditor(record)}>编辑大屏</a>
                    </PermissionWrapper>

                    <PermissionWrapper permissionCodePath="system-overview.big-screen-management.update-big-screen">
                        <a onClick={()=> onEditBigScreenInfo(record)}>修改信息</a>
                    </PermissionWrapper>

                    <PermissionWrapper permissionCodePath="system-overview.big-screen-management.delete-big-screen">
                        <Popconfirm
                                title="删除大屏"
                                description={ <div style={{paddingTop: "10px", paddingBottom: '10px'}}>确认要删除该大屏么? 删除后数据无法恢复</div> }
                                onConfirm={()=> onDeleteBigScreen(record)}
                                okText="确定"
                                cancelText="取消"
                            >
                            <a>删除</a>
                        </Popconfirm>
                    </PermissionWrapper>
                </Space>
            }
        }
    ];

    let filteredBigScreenViews = [].concat(bigScreenViews);
    if (searchValue) {
        filteredBigScreenViews = filteredBigScreenViews.filter((e)=> {
            let name = e.bigScreen.name || '';
            let editorUrl = e.bigScreen.editorUrl || '';
            let remarks = e.bigScreen.remarks || '';
            if (name.indexOf(searchValue)>=0
            || editorUrl.indexOf(searchValue)>=0
            || remarks.indexOf(searchValue)>=0) {
                return true;
            }
            return false;
        });
    }

    // effect
    useEffect(()=> {
        loadBigScreenViews();
    }, []);

    // render
    return (
        <BigScreenManagementWrapper>
            {contextHolder}
            <ToolBarWrapper>
                <ToolBarLeftWrapper>
                    <Space size="middle">
                        <PermissionWrapper permissionCodePath="system-overview.big-screen-management.create-big-screen">
                            <Button type="primary" icon={<PlusOutlined />} onClick={onAddBigScreenClick}>创建大屏</Button>
                        </PermissionWrapper>
                    </Space>
                </ToolBarLeftWrapper>

                <ToolBarRightWrapper>
                    <Input
                        placeholder="请输入名称/编辑器地址/备注"
                        suffix={<SearchOutlined />}
                        size="middle"
                        onChange={onInputChange} />
                </ToolBarRightWrapper>

                <Modal open={openCreateBigScreenModal}
                    onClose={()=> setOpenCreateBigScreenModal(false)}
                    destroyOnClose={true}
                    footer={null}
                    closable={false}
                    width={700}
                    height={500}
                    >
                    <CreateBigScreenWizard
                        bigScreenId={editingBigScreenId}
                        onClose={()=> setOpenCreateBigScreenModal(false)}
                        onComplete={()=> {
                            setOpenCreateBigScreenModal(false);
                            loadBigScreenViews();
                        }}/>
                </Modal>
            </ToolBarWrapper>
            <TableWrapper>
                <Table
                    rowKey={(record)=> record.bigScreen.id}
                    columns={columns}
                    dataSource={filteredBigScreenViews}
                    loading={loading}
                />
            </TableWrapper>
        </BigScreenManagementWrapper>
    );
}

export default BigScreenManagement;
